<template>
  <v-card class="elevation-0 mr-4 mb-2">
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.endpoint_type") }}
    </div>
    <v-row class="ml-2">
      <v-col cols="8" xs="12">
        <v-select v-model="selectedEndpoint" :items="ENDPOINTS"
          item-text="label"
          item-value="value"
          :label= '$vuetify.lang.t("$vuetify.ai_response.select_endpoint_type")' outlined required
          >
        </v-select>
      </v-col>
    </v-row>
    <template v-if="selectedEndpoint === 'Recommendation'">
      <Recommendation />
    </template>
    <template v-else>
      <Search />
    </template>
  </v-card>
</template>

<script>
import Recommendation from "@/components/Projects/Recommendation/Recommendation";
import Search from "@/components/Projects/Search/Search";
import { mapState } from "vuex";

export default {
  components: {
    Recommendation,
    Search
  },
  computed: {
    ...mapState({
    }),
  },
  data() {
    return {
      selectedEndpoint: "Recommendation",
      ENDPOINTS: [
        {value:"Recommendation", label:this.$vuetify.lang.t("$vuetify.ai_response.recommendation")},
        {value:"Search", label:this.$vuetify.lang.t("$vuetify.ai_response.search")}],
    };
  },

};
</script>

<style scoped></style>
